<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <form [formGroup]="leaveapplicationForm">
          <div class="canvas-item">
            <div class="canvas-header row justify-content-between align-items-center">
              <div class="title col-sm-6">
                <div class="d-flex align-items-center">
                  <div class="edit">
                    <button title="back page" (click)="backToMyLeave()">
                      <span><i class="ri-arrow-left-line"></i></span>
                    </button>
                  </div>
                  <h3 class="px-3">Leave Application</h3>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <div class="canvas-data">
                  <div class="row">
                    <div class="col-sm-12 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input type="text" formControlName="applicationTitle" disabled required>
                          <label class="floating-label-special">Application Title</label>
                          <i class="ri-calendar-todo-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input type="date" formControlName="applicationDate" disabled required>
                          <label class="floating-label-special">Application Date</label>
                          <i class="ri-user-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input list="taskOwnerDatalist" placeholder="Applied For" disabled formControlName="userIdUserName">
                          <datalist id="taskOwnerDatalist">
                            <option [value]="item" *ngFor="let item of userDropdownList">
                          </datalist>
                          <label class="floating-label floating-label-special">Applied For</label>
                          <i class="ri-shield-user-line"></i>
                        </div>
                      </div>
                    </div>
                   
                    <div class="col-sm-12 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <select disabled formControlName="leavetype">
                            <option value="" disabled selected>Select leave type</option>
                            <option value="Earned Leave">Earned Leave</option>
                            <option value="Casual Leave">Casual Leave</option>
                            <option value="Compensatory leave">Compensatory leave</option>
                          </select>
                          <label for="leavetype" class="floating-label floating-label-special">Leave Type</label>
                          <i class="ri-user-line"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input type="date" formControlName="startDate" disabled required>
                          <label class="floating-label-special">From</label>
                          <i class="ri-building-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input type="date" formControlName="endDate" disabled required>
                          <label class="floating-label-special">To</label>
                          <i class="ri-file-text-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input type="text" formControlName="duration" disabled required>
                          <label class="floating-label-special">Duration</label>
                          <i class="ri-file-text-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input list="taskOwnerDatalist" formControlName="delegatedToUserName" disabled placeholder=" Select Delegation">
                          <datalist id="taskOwnerDatalist">
                            <option [value]="item" *ngFor="let item of userDropdownList">
                          </datalist>
                          <label class="floating-label floating-label-special">Delegation</label>
                          <i class="ri-file-copy-2-line"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <textarea name="" id="" cols="30" rows="4" disabled formControlName="leaveReason"></textarea>
                          <label class="floating-label-special">Comment</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <select formControlName="status">
                            <option value="Submit" disabled>Submit</option>
                            <option value="Approved" *ngIf="this.leaveStatus != 'Withdraw After Approval'">Approved</option>
                            <option value="Reject" *ngIf="this.leaveStatus != 'Withdraw After Approval'">Reject</option>
                            <option value="Approved" *ngIf="this.leaveStatus === 'Withdraw After Approval'">Reject Withdraw</option>
                            <option value="Withdraw" *ngIf="this.leaveStatus === 'Withdraw After Approval'">Accept Withdraw</option>
                          </select>
                          <label for="status" class="floating-label floating-label-special"> Select Status</label>
                          <i class="ri-logout-box-r-line"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input type="date" formControlName="approvedDate" disabled>
                          <label class="floating-label">Approved Date</label>
                          <i class="ri-file-text-line"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6 px-3 py-1">
                      <div class="input">
                        <div class="input-item">
                          <input type="file" disabled required placeholder="Attachment">
                          <i class="ri-calendar-line"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row justify-content-end align-items-center">
                    <div class="col-sm-3 text-end px-3 py-1">
                      <button type="button" id="closeCreateModal" class="btn" (click)="addleaveAppRates()">Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </section>
  </article>
</main>
